<template>
  <svg
    viewBox="0 0 5 3"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      width="5"
      height="1"
      fill="#000"
    />
    <rect
      y="1"
      width="5"
      height="1"
      fill="#DD0000"
    />
    <rect
      y="2"
      width="5"
      height="1"
      fill="#FFCE00"
    />
  </svg>
</template>

<script>
export default { name: 'FlagDe' };
</script>
